export default __webpack_public_path__ + "static/AL_Birmingham_ATD_Oak-Mountain-Statepark1920px-25707d3cf71fc45558e35c89b791323c.jpg";